import Config from '@config';
import { initializeGasPipelineSectionsApi } from '@gasbi/shared/common/features/gasPipelineSections';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  gasPipelineSectionsApi,
  useGetGasPipelineSectionsQuery,
  useGetGasPipelineSectionsIInfiniteQuery,
} = initializeGasPipelineSectionsApi(Config.VITE_API_URL, axiosBaseQuery);
